const STORAGE_KEY = "sa:resolved";

export const normalize = (value) =>
  (value ?? "").toString().trim().split(" ").join("_").toLowerCase();

const readStore = () => {
  if (typeof window === "undefined") {
    return {};
  }

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw);
    return typeof parsed === "object" && parsed !== null ? parsed : {};
  } catch (error) {
    console.warn("Speaker Attribution: failed to read resolved issues from storage", error);
    return {};
  }
};

const writeStore = (store) => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch (error) {
    console.warn("Speaker Attribution: failed to persist resolved issues", error);
  }
};

export const loadResolvedSet = (workflowId) => {
  if (!workflowId) {
    return new Set();
  }

  const store = readStore();
  const entries = store[workflowId];
  return Array.isArray(entries) ? new Set(entries) : new Set();
};

export const saveResolvedSet = (workflowId, set) => {
  if (!workflowId) {
    return;
  }

  const store = readStore();
  store[workflowId] = Array.from(set);
  writeStore(store);
};

// The DOM id the editor gives a snippet: its start time as H:MM:SS followed by "zz".
export const snippetElementId = (ms) =>
  `${[
    Math.floor(ms / 3600000),
    String(Math.floor((ms / 60000) % 60)).padStart(2, "0"),
    String(Math.floor((ms / 1000) % 60)).padStart(2, "0"),
  ].join(":")}zz`;

export const makeIssueKey = ({ category, entity, startTime }) =>
  `${normalize(category)}:${normalize(entity)}:${startTime}`;

export const addResolved = (workflowId, key) => {
  if (!workflowId) {
    return;
  }

  const existing = loadResolvedSet(workflowId);
  if (!existing.has(key)) {
    existing.add(key);
    saveResolvedSet(workflowId, existing);
  }
};

export const removeResolvedSet = (workflowId) => {
  if (!workflowId) {
    return;
  }

  const store = readStore();
  delete store[workflowId];
  writeStore(store);
};
